<template>
    <PageView>
        <a-card title="访问UV排行">
            <a-row :gutter="10" class="inputGroup">
                <a-col :xs="12" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.url" placeholder="跳转url" />
                </a-col>
                <a-col :xs="12" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.from_app_id" placeholder="小程序ID" />
                </a-col>
                <a-col :xs="12" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.from_app_name" placeholder="小程序名称" />
                </a-col>
                <a-col :xs="12" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.from_shop_name" placeholder="主体名称" />
                </a-col>
                <a-col :xs="12" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.from_code" placeholder="数据源" />
                </a-col>

                <a-col :xs="12" :md="3" :lg="3" :xl="2">
                    <a-select allowClear v-model="searchData.day" style="width:100%" placeholder="请选择天数">
                        <a-select-option :value="value.id" v-for="(value, key) in day_list" :key="key">{{value.name}}</a-select-option>
                    </a-select>
                </a-col>

                <a-col :xs="12" :md="6" :lg="6" :xl="12">
                    <a-button-group>
                        <a-button type="primary" :loading="loading" @click="getList">确定筛选</a-button>
                    </a-button-group>
                    <a-button-group style="margin-left:10px">
                        <a-button type="primary" :loading="loading" @click="getListInit">重置</a-button>
                    </a-button-group>
                </a-col>
                <a-span style="float: right">总计:<span style="font-weight:bold;">{{uvTotal}}</span>条</a-span>
            </a-row>
            <a-table
                :loading="loading"
                :columns="columns"
                :dataSource="data"
                :pagination="{total, pageSize, showSizeChanger, current }"
                @change="changePagination"
                bordered
                :scroll="{ x: true }"
            >
            </a-table>
        </a-card>
    </PageView>
</template>

<script type="text/jsx">
import User from '../../api/User.js'
import { mapGetters } from 'vuex'
import Goods from "@/api/Goods";
export default {
    name: 'memberList',
    data () {
        return {
            loading: true,
            Password: false,
            time:[],
            lent:{
                url:'',
                from_app_id:'',
                from_app_name:'',
                from_shop_name:'',
                from_code:'',
                day:'',
            },
            columns: [
                {
                    title: '来源APPID',
                    dataIndex: 'from_app_id',
                    customRender: (v) => {
                        return v || '空'
                    }
                },
                {
                    title: '来源APP名称',
                    dataIndex: 'from_app_name',
                    customRender: (v) => {
                        return v || '空'
                    }
                },
                {
                    title: '主体名称',
                    dataIndex: 'from_shop_name',
                    customRender: (v) => {
                        return v || '空'
                    }
                },
                {
                    title: '数据源',
                    dataIndex: 'from_code',
                    customRender: (v) => {
                        return v || '空'
                    }
                },
                {
                    title: 'UV数量',
                    dataIndex: 'count',
                    customRender: (v) => {
                        return v || '空'
                    }
                },
                {
                    title: '跳转地址',
                    dataIndex: 'URL',
                    customRender: (v) => {
                        return v || '空'
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    fixed: 'right',
                    width: 110,
                    customRender: (v) => {
                        return (
                            <a-button-group>
                                <a-button
                                    type="primary"
                                    onClick={()=>{
                                        this.$router.push({name:`addprovider`,query: { id: v.from_app_id}})
                                    }}>
                                    编辑小程序
                                </a-button>
                            </a-button-group>
                        )

                    }
                }
            ],
            data: [],
            total: 0,
            uvTotal:0,
            pageSize: 40,
            current: 1,
            showSizeChanger: true,
            day_list: [],  //  获取天数
            day:0,
            searchData: {
                url:'',
                from_app_id: '',
                from_app_name: '',
                from_shop_name: '',
                from_code: '',
                day:'',
            },
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 }
            },
            btnloading: false,
            radioStyle: {
                display: 'block',
                height: '30px',
                lineHeight: '30px',
            },
        }
    },
    activated () {
        this.init();
        this.getList()
    },
    methods: {
        ...mapGetters(['nickid']),
        getListInit(){
            this.searchData.day = ''
            this.searchData.url = ''
            this.searchData.from_app_id = ''
            this.searchData.from_app_name = ''
            this.searchData.from_shop_name = ''
            this.searchData.from_code = ''
            this.current = 1
            this.getList()
        },
        init() {
            this.day = 0;
            User.day_list().then(res => {
                this.day_list = res.result;
            })
        },
        getList () {
            this.loading = true
            User.agent_access_top({
                page: this.current,
                num: this.pageSize,
                day: this.day,
                ...this.searchData,
            }).then(res => {
                this.data = res.result.map((value, key) => {
                    return { ...value, key }
                })
                this.loading = false
                this.uvTotal = parseInt(res.uvTotal);
                this.total = parseInt(res.count);
            })
        },

        changePagination (pagination) {
            Object.keys(pagination).forEach(val => {
                this[val] = pagination[val]
            })
            this.getList()
        },

        formatJson (filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        }
    }
}
</script>

<style scoped lang="less">
.inputGroup {
    > div {
        margin-bottom: 20px;
    }
}

.radioTitle {
    display: block;
    font-size: 18px;
    padding: 20px 0px;
}

.radioStyle {
    display: block;
    height: 30px;
    lineheight: 30px;
    margin-left: 20px;
}
</style>
